export const register = () => {
  if ('serviceWorker' in navigator) {
    if (typeof window !== 'undefined') {
      window.addEventListener('load', () => {
        navigator.serviceWorker
          .register('/service-worker.js')
          .then((registration) => {
            console.log('Service Worker registered with scope:', registration.scope);
          })
          .catch((error) => {
            console.error('Service Worker registration failed:', error);
          });
      })
    } else {
      console.error('Window is undefined')
    }
  } else {
    console.error('serviceWorker is not in navigator')
  }
}